import * as React from "react";
import { ReservesSearchForm } from "../../ReservesSearchForm";
import { Box, Container } from "@mui/material";
import { ReservesSearchResults } from "./Reserves/ReservesSearchResults";
import { FILTER_SIDEBAR_WIDTH, useShowFilterSidebar } from "./LSSearchResults";
import { ReservesProvider } from "./Reserves/ReservesSearchProvider";

export const ReservesSearchPage: React.FC = () => {
  const showFilterSidebar = useShowFilterSidebar();

  return (
    <ReservesProvider>
      <Container>
        <Box
          display="flex"
          gap={3}
          component="main"
          role="main"
          aria-label="Academic Reserves Search"
        >
          {showFilterSidebar && (
            <Box
              sx={{
                width: FILTER_SIDEBAR_WIDTH,
                pt: 2,
                flexShrink: 0,
              }}
            >
              <ReservesSearchForm />
            </Box>
          )}
          <Box flex={1} component="section" aria-label="Search Results">
            <ReservesSearchResults />
          </Box>
        </Box>
      </Container>
    </ReservesProvider>
  );
};
